<zui-form-section
  [isZen]="isZen"
  [separator]="'none'">

  <span *zuiFormSectionTitle>
    {{ translations.hostnameTitle }}
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>
      <span [innerHTML]="translations?.hostnameDesc | safeHtml"></span>
    </zui-docs-text>
  </div>

  <zef-form-field last>

    <z-hostname-field
      [label]="translations.hostnameLabel"
      [placeholder]="translations.hostnamePlaceholder"
      [control]="state?.controls.name">
    </z-hostname-field>

  </zef-form-field>

</zui-form-section>

<zui-separator
  [orientation]="'vertical'"
  [size]="'medium'"
  [spacing]="'large'"
  [position]="'center'"
/>

<zui-form-section
  [isZen]="isZen"
  [separator]="'none'"
  class="__scaling-section">

  <span *zuiFormSectionTitle>
    Automatic Scaling
  </span>

  <div *zuiFormSectionDesc>
    <zui-docs-text>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Elasticsearch">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Meilisearch">
        This service runs as a single instance since highly available Meilisearch clustering is not yet supported in open-source versions.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Typesense">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.RabbitMq">
        This service can run as a single container or in HA mode with 3 containers and 2 load balancers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Redis">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.MongoDb">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.MariaDb">
        This service can run as a single container or in HA mode with 3 containers and 2 load balancers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Postgres">
        This service can run as a single container or in HA mode with 3 containers and 2 load balancers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Clickhouse">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. Additional clustering modes are planned for future releases.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Qdrant">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Valkey">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Nats">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

      @if (serviceStackType === serviceStackTypes.Seaweedfs) {
        This service can run as a single container or in HA mode with 2 containers with the data replicated between them.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      }

      <ng-container *ngIf="serviceStackType === serviceStackTypes.Kafka">
        This service can run as a single container or in HA mode with 3 containers for optimal performance.
        Zerops automatically <a data-zui-new-docs="features/scaling#part-1-resource-management">scales vertically</a>
        by adjusting container resources based on current load. You can fine-tune the scaling ranges to fit your specific needs.
      </ng-container>

    </zui-docs-text>
  </div>

  <zef-form-field>
    <zui-autoscaling-form-field
      [serviceStackType]="serviceStackType"
      [supportsVerticalAutoscaling]="supportsVerticalAutoscaling"
      [ngrxFormControlState]="state?.controls.customAutoscaling"
      [defaultHorizontalAutoscaling]="defaultHorizontalAutoscaling"
      [defaultVerticalAutoscaling]="defaultVerticalAutoscaling"
      [horizontalPlaceholder]="horizontalPlaceholder"
      [verticalPlaceholder]="verticalPlaceholder"
      [autoscalingProfiles]="autoscalingProfiles"
    />
  </zef-form-field>

</zui-form-section>
